import { GraphQLClient } from "graphql-request"

import EnvVars from "../../env-vars"

const { API_URL = `` } = EnvVars

const makeGraphqlRequestClient = (token: string): GraphQLClient =>
  new GraphQLClient(`${API_URL}/graphql`, {
    headers: {
      "Content-Type": `application/json`,
      "Authorization": `Bearer ${token}`,
    },
  })

export default makeGraphqlRequestClient
